import apiClient from '../apiClient';
import { PUT_DATA_TRANSFER_LOGS_URL } from '../apiUrl';

const putDataTransferLogsApi = (id, data) => {
  return apiClient.put(PUT_DATA_TRANSFER_LOGS_URL(id), data);
};

export default putDataTransferLogsApi;
